$(() => {
    $(document).on('click', '.js-ajax-modal', (e) => {
        e.preventDefault();
        const src = $(e.currentTarget).data('href') || $(e.currentTarget).attr('href');
        const hrefMatch = src.match(/#(.*)$/);
        const hash = hrefMatch ? hrefMatch[0] : undefined;
        $.get(src, (html) => {
            const $content = $(html).find(hash);
            $.fancybox.open($content, {
                closeExisting: true,
                src,
                filter: hash,
                type: 'ajax',
                baseClass: 'b-ajax-modal',
                slideClass: 'b-ajax-modal__slide',
                touch: false,
                btnTpl: {
                    smallBtn: `
                        <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small b-ajax-modal__close" title="{{CLOSE}}">
                            <svg viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line y1="-0.5" x2="37.8844" y2="-0.5" transform="matrix(-0.705147 -0.709061 0.705147 -0.709061 27.7142 27.8573)" stroke="black"/>
                                <line y1="-0.5" x2="37.8855" y2="-0.5" transform="matrix(0.704396 -0.709807 0.704396 0.709807 1.00073 28.8507)" stroke="black"/>
                            </svg>
                        </button>
                    `
                },
            });
        }); 
    });
});
